var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmartDelivery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 21,
    viewBox: "0 0 26 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 20.8237,
    rx: 5.73468,
    fill: "#299796",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.01626 15.2089L11.4883 9.5178L13.8371 13.0045H13.8372C13.9668 13.1968 14.1817 13.3158 14.4151 13.3243C14.6483 13.333 14.8715 13.2301 15.0152 13.0477L20.1055 6.56417C20.2378 6.41462 20.3016 6.21764 20.2823 6.01967C20.2628 5.82189 20.1617 5.64082 20.0029 5.51927C19.844 5.39786 19.6416 5.34673 19.4436 5.37824C19.2454 5.4096 19.0693 5.52071 18.9566 5.68521L14.4846 11.3763L12.1358 7.88967H12.1356C12.0019 7.68834 11.7755 7.56677 11.5322 7.56549C11.297 7.5568 11.072 7.66148 10.9287 7.84641L5.8383 14.33C5.69838 14.5343 5.67387 14.7953 5.77321 15.0216C5.87255 15.248 6.0821 15.4082 6.32816 15.4461C6.5744 15.484 6.82307 15.3946 6.98717 15.2089L7.01626 15.2089Z",
    fill: "#4B4B4B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartDelivery);
export default __webpack_public_path__ + "static/media/smart_delivery.601209ad178ff4e9e343cb38d87f79af.svg";
export { ForwardRef as ReactComponent };